<template>
    <div>
      <table class="table table-historial table-hover table-striped">
        <thead>
            <tr>
                <th>Liq</th>
                <th>Accion</th>
                <th>Fecha</th>
                    <th>extra</th>

            </tr>
        </thead>
        <tbody>
            <tr v-for="h in orderBy(historial, 'fecha', -1)" :key="h.fecha">
<td>{{h.id_fo_liq}}</td>
    <td>{{ h.tipo }}</td>
    <td>{{ h.fecha |  moment("from", "now") }}</td>
    <td>

        <el-tooltip :content="'pagina: '+h.pagina+' - estado: ' + h.estado+ ' - cliente: ' + h.cliente" placement="right" effect="dark">
            <span>  p:{{ h.pagina }}e:{{ h.estado }}c:{{ h.cliente }}</span>
        </el-tooltip>
        
      
      
        
        </td>
            </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
import Vue2Filters from "vue2-filters";
    export default {
            mixins: [Vue2Filters.mixin],

        data() {
            return {
                historial: window.localStorage.getItem('historial') ? JSON.parse(window.localStorage.getItem('historial')) : []
            }
        },
        created()
        {
            if(this.historial.length)
            {
            let fechaHoy = new Date().toISOString();
            let newHistorial = this.historial.filter(objeto => objeto.fecha.slice(0, 19) === fechaHoy.slice(0, 19));
            window.localStorage.removeItem('historial')
            setTimeout(() => {
                window.localStorage.setItem('historial', JSON.stringify(newHistorial))
                
            }, 100);
            }
        

        }
        
       
    }
</script>

<style lang="scss" scoped>
.table-historial thead > tr > th{
    text-align: left;
}
.table-historial tbody > tr > td{
    cursor: pointer;
}
</style>